import { getEnv } from '@/helpers/getEnv';

export * from './paths';

export const STAGE: string = getEnv<string>('VITE_STAGE') ?? 'prod';
export const IS_DEV: boolean = STAGE === 'dev';
export const IS_STAGING: boolean = ['demo'].includes(STAGE);
export const IS_PREPROD_OR_PROD: boolean = ['preprod', 'prod'].includes(STAGE);
export const AUTHORIZED_LANGUAGES = ['en', 'fr'];
export const DEFAULT_LANGUAGE = 'en';
export const DEBUG_LANGUAGE = 'dt';
export const GRAPHQL_GATEWAY_URL: string = getEnv<string>('VITE_GRAPHQL_GATEWAY_URL');
export const TRANSLATIONS_ENDPOINT_URI: string = getEnv<string>('VITE_TRANSLATIONS_ENDPOINT_URI');
export const B2B_PORTAL_URL: string = getEnv<string>('VITE_B2B_PORTAL_URL');
export const BOP_URL: string = getEnv<string>('VITE_BOP_URL');
export const B2C_WEBSITE_URL: string = getEnv<string>('VITE_B2C_WEBSITE_URL');
export const GOOGLE_RECAPTCHA_ENTERPRISE_PUBLIC_KEY: string = getEnv<string>(
  'VITE_GOOGLE_RECAPTCHA_ENTERPRISE_PUBLIC_KEY'
);
export const AUTH_COOKIE_DOMAIN: string = getEnv<string>('VITE_AUTH_COOKIE_DOMAIN');
export const AUTH_TOKEN_KEY = 'auth_token';
export const DATE_FORMATS = {
  FULL_DATE: 'yyyy/MM/dd HH:mm',
  FULL_DATE_TO_SEND: 'yyyy-MM-dd HH:mm:ss',
  DATE_ONLY: 'yyyy/MM/dd',
  DATE_TO_SEND: 'yyyy-MM-dd',
  DAY_ONLY: 'dd',
  MONTH_YEAR_ONLY: 'MMMM yyyy',
  TIME_ONLY: 'HH:mm',
};
export const TEST_TYPES_PROGRAMS = {
  PROGRAM_PP: 10,
  PROGRAM_IP: 20,
};

export const TEST_TYPES_FORMATS = {
  FORMAT_CBT: 10,
  FORMAT_PBT: 20,
};
